import SVTAPI from './svtapi';

class StorageEvent extends SVTAPI {
  /**
   * Initializes the API for an existing storage event.
   *
   * @param {number} [pid] - The pid of an existing storageEvent, if applicable
   */
  constructor(pid = false) {
    super('/storage-event');
    if(pid) this._pid = pid;
  }

  post(data) {
    return super.post({ data })
  }

  /**
   * PATCH /storage-event/:pid
   * Updates an existing item's storage event.
   *
   * @param   {Object} data The data to update
   * @returns {Object}      The server's response
   */
  patch(data) {
    return super.patch({ url: '/' + this._pid, data });
  }

  /**
   * DELETE /storage-event/:pid
   * Marks the storage event as removed (soft delete)
   *
   * @returns {Object}      The server's response
   */
  remove() {
    return super.remove({ url: '/' + this._pid });
  }
}
export default StorageEvent
